import { Loader } from '@pwc/pwc-deals-ui';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { SURVEY_DIRECTION } from '../../common/services/utilities/surveyUtility';
import {
  formatSurveyQuestionRoute,
  formatContentResponsesRoute,
} from '../../routes';
import {
  fetchNextQuestion,
  fetchPreviousQuestion,
  fetchSurveyResponses,
  getFetchQuestionStatus,
  getFetchSurveyResponsesStatus,
  getQuestion,
  getSurveyResponses,
} from '../../surveySlice';

const SurveyProceed = ({ direction }) => {
  const { success: fetchQuestionSuccess } = useSelector(getFetchQuestionStatus);
  const { success: fetchSurveyResponsesSuccess } = useSelector(
    getFetchSurveyResponsesStatus
  );
  const question = useSelector(getQuestion);
  const surveyResponses = useSelector(getSurveyResponses);

  const dispatch = useDispatch();
  const history = useHistory();

  const { projectId } = useParams();

  const isReadyToProceed = fetchQuestionSuccess && fetchSurveyResponsesSuccess;

  useEffect(() => {
    if (!fetchQuestionSuccess) {
      const questionOrder = question ? question.order : null;
      const navigateForward = direction === SURVEY_DIRECTION.NEXT;
      const navigateBackward = direction === SURVEY_DIRECTION.PREVIOUS;

      if (navigateForward) {
        dispatch(fetchNextQuestion(projectId, questionOrder));
      }
      if (navigateBackward) {
        dispatch(fetchPreviousQuestion(projectId, questionOrder));
      }
      dispatch(fetchSurveyResponses(projectId));
    }
  }, [dispatch, projectId, question, fetchQuestionSuccess, direction]);

  useEffect(() => {
    if (isReadyToProceed) {
      let redirectPath;
      if (question) {
        const section = surveyResponses.sections.find(
          (s) => s.id === question.sectionId
        );
        redirectPath = formatSurveyQuestionRoute(
          projectId,
          section.path,
          question.id
        );
      } else {
        redirectPath = formatContentResponsesRoute(projectId, 'survey');
      }
      history.replace(redirectPath);
    }
  }, [question, isReadyToProceed, history, projectId, surveyResponses]);

  return <div>{!fetchQuestionSuccess && <Loader />}</div>;
};

export default SurveyProceed;
